import React from 'react';
import { useParams, Link } from 'react-router-dom';
import MetaData from '../MetaData';

import '../assets/styles/singleWork.css';
import { WorkData } from '../assets/config';

import DefaultNavbar from '../components/DefaultNavbar';
import StickySection from '../components/singleWork/StickySection';
import ContactSection from '../components/ContactUs/ContactSection';
import { paths } from 'routes/routes/paths';

function SingleWorks() {
  const params = useParams<{ id: string }>();
  const singleWorkData = WorkData.find((i: any) => String(i.id) === params.id);

  return (
    <>
      <MetaData title={'Home'} content={''} />
      <DefaultNavbar />
      <main className="h-full pt-20">
        <div className="relative mb-40 block pt-10">
          <div className="container max-w-7xl mx-auto px-4">
            <StickySection />
            {singleWorkData?.isStudyAvailable && (
              <div className="flex justify-center mt-12 mb-8 relative z-1">
                <button
                  onClick={() => {
                    const overlay = document.createElement('div');
                    overlay.style.position = 'fixed';
                    overlay.style.top = '0';
                    overlay.style.left = '0';
                    overlay.style.width = '100vw';
                    overlay.style.height = '100vh';
                    overlay.style.backgroundColor = '#1881bb';
                    overlay.style.zIndex = '9999';
                    overlay.style.transform = 'translateY(100%)';
                    overlay.style.transition = 'transform 0.8s cubic-bezier(0.77, 0, 0.175, 1)';
                    document.body.appendChild(overlay);

                    // Trigger the animation shortly after appending
                    setTimeout(() => {
                      overlay.style.transform = 'translateY(0)';
                      window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth'
                      });
                    }, 50);

                    // Navigate after animation completes
                    setTimeout(() => {
                      window.location.href = paths.public.caseStudy(singleWorkData.id);
                    }, 850);
                  }}
                  className="bg-[#1881bb] text-black px-8 py-3 rounded-full font-satoshi-medium flex items-center gap-2 hover:bg-[#156a9a] transition-colors shadow-lg group"
                >
                  View Case Study
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="transform transition-transform duration-300 group-hover:translate-y-1"
                  >
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <polyline points="19 12 12 19 5 12"></polyline>
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>
      </main>
      <ContactSection />
    </>
  );
}

export default SingleWorks;
